export const ticketsTableColumns = [
  {
    title: "Ticket ID",
    key: "id",
    dataIndex: "id",
    width: 110,
    sorter: (a, b) => a.id - b.id,
    sortDirections: ["descend"],
    slots: { customRender: "ticketId" },
    fixed: "left",
    code: "ticket_id",
  },
  {
    title: "Estado (s)",
    key: "state",
    dataIndex: "state",
    width: 100,
    slots: { customRender: "state" },
    fixed: "left",
    code: "status",
  },
  {
    title: "Contacto",
    key: "contact",
    dataIndex: "contact",
    width: 230,
    slots: { customRender: "contact" },
    fixed: "left",
    code: "contact",
  },
  {
    title: "Gestionado por:",
    key: "managedBy",
    dataIndex: "managedBy",
    ellipsis: true,
    width: 190,
    slots: { customRender: "managedBy" },
    code: "assigned_user",
  },
  {
    title: "Canal",
    key: "managedBy",
    dataIndex: "channels",
    width: 140,
    slots: { customRender: "channels", title: "channels_title" },
    code: "channels",
  },
  {
    title: "Identificadores de canales",
    key: "identifyChannels",
    dataIndex: "identifyChannels",
    width: 200,
    slots: { customRender: "identifyChannels", title: "identifyChannels_title" },
    ellipsis: true,
    code: "channels_identifiers",
  },
  {
    title: "Teléfono del contacto",
    key: "callsContact",
    dataIndex: "callsContact",
    width: 200,
    slots: { customRender: "callsContact", title: "callsContact_title" },
    ellipsis: true,
    code: "phone_contact",
  },
  {
    title: "Nombre de usuario en WhatsApp",
    key: "whatsapp_username",
    dataIndex: "whatsapp_username",
    width: 260,
    slots: { customRender: "whatsapp_username" },
    code: "whatsapp_username",
  },
  {
    title: "Identificador de WhatsApp",
    key: "whatsapp_user_id",
    dataIndex: "whatsapp_user_id",
    width: 260,
    slots: { customRender: "whatsapp_user_id" },
    code: "whatsapp_user_id",
  },
  {
    title: "Cola",
    key: "queue",
    dataIndex: "queue",
    width: 170,
    slots: { customRender: "queues" },
    ellipsis: true,
    code: "queues",
  },
  {
    title: "Etiquetas",
    key: "tags",
    dataIndex: "tags",
    width: 170,
    slots: { customRender: "tags" },
    code: "tag",
  },
  {
    title: "Tipo de interacción",
    key: "interaction_type",
    dataIndex: "interaction_type",
    width: 170,
    code: "type_interaction",
  },
  {
    title: "Último tipo de contacto",
    key: "last_management_group",
    dataIndex: "last_management_group",
    width: 200,
    sorter: (a, b) => a.contact_type.localeCompare(b.contact_type),
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "contactType" },
    code: "last_type_contact",
  },
  {
    title: "Fecha de última interacción",
    key: "last_interaction_date",
    dataIndex: "last_interaction_date",
    width: 230,
    sorter: (a, b) => new Date(b.last_interaction_date) - new Date(a.last_interaction_date),
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "date" },
    code: "last_date_interaction",
  },
  {
    title: "Fecha de creación",
    key: "created_at",
    dataIndex: "created_at",
    width: 180,
    sorter: (a, b) => new Date(b.created_at) - new Date(a.created_at),
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "date" },
    code: "date_created",
  },
  {
    title: "Empresa",
    key: "entity",
    dataIndex: "entity",
    width: 230,
    sorter: (a, b) => a.entity.localeCompare(b.entity),
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "entity" },
    code: "entity_name",
  },
  {
    title: "Nombre de la Campaña",
    key: "portfolio",
    dataIndex: "portfolio",
    width: 230,
    sorter: (a, b) => a.portfolio.localeCompare(b.portfolio),
    sortDirections: ["descend", "ascend"],
    code: "portfolio_name",
  },
  {
    title: "Resuelto/cerrado mediante",
    key: "type_closed",
    dataIndex: "type_closed",
    width: 200,
    slots: { customRender: "type_closed" },
    code: "type_closed",
  },
  {
    key: "closed_by",
    dataIndex: "closed_by",
    width: 200,
    slots: { customRender: "closed_by", title: "closed_by_title" },
    code: "closed_by",
  },
  {
    title: "Acciones",
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    width: 150,
    slots: { customRender: "actions" },
    code: "actions",
  },
];
